var _effectorFileName = "/src/page-content/pair-lessons/ui.tsx";
import { useRouter } from 'next/router';
import { WebPageJsonLd } from 'next-seo';
import { HelpAchieveGoals } from '@/page-content/pair-lessons/components/help-achieve-goals';
import { MainPairLessons } from '@/page-content/pair-lessons/components/main-pair-lessons';
import { PlusesPairLessons } from '@/page-content/pair-lessons/components/pluses-pair-lessons';
import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { SERVICES_LIST } from '@/widgets/layouts/main/constants/services-list';
import { Pricing } from '@/widgets/layouts/main/pricing/pricing';
import { Reviews } from '@/widgets/layouts/main/reviews';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
export const PairLessonsPage = () => {
  const router = useRouter();
  return <>
      <PageSeo title="Парные занятия" description={`Занятия с коллегой из вашей или смежной сферы помогут быстрее прокачать разговорные навыки и преодолеть языковой барьер. ${APP_TITLE} – деловой английский для работы.`} />

      <WebPageJsonLd id={router.asPath} url={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} name={`${APP_TITLE} - Парные занятия`} isPartOf={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} description={`Занятия с коллегой из вашей или смежной сферы помогут быстрее прокачать разговорные навыки и преодолеть языковой барьер. ${APP_TITLE} – деловой английский для работы.`} about={['английский', 'онлайн', 'парные занятия']} />

      <MainPairLessons />

      <HelpAchieveGoals />

      <PlusesPairLessons />

      <Pricing servicesList={SERVICES_LIST} />

      <Reviews />

      <CallToAction withForm />
    </>;
};
PairLessonsPage.Layout = MainLayout;